import { HOME_URL } from "../constants";

export const generateCanonicalLinkForSEO = location => {
  const { pathname, search } = location;
  const href = `${HOME_URL}${pathname}${search}`;
  return <link rel="canonical" href={href} />;
};
